<section *ngIf="!url" class="application-wrap">
  <div class="wrap-lg">
    <div class="application-inner">
      <!-- <div class="nav-sec">
        <div class="back-nav" (click)="util.route('home')">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="#1A204B" stroke-width="1.75" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span class="nav-name">Back</span>
        </div>
      </div>
      <div class="page-head">
        <div class="head-left">
          <div class="page-title">Application Letter</div>
          <div class="page-info">We need everyone to sign the application letter to proceed further.</div>
        </div>
      </div> -->
      <div class="box-wrap">
        <div class="application-list">
          <div class="appln-item  {{ user.signed? 'completed' : (user.selected?'pending':'')}}" (click)="unSelectUsers(i);" *ngFor="let user of signerDetails; index as i">
            <div class="appln-name">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g id="profile">
                <path id="Vector" d="M9.84846 15.5498C11.2881 15.4338 12.7344 15.4338 14.1741 15.5498C14.9581 15.5955 15.7383 15.6936 16.5099 15.8434C18.1796 16.1815 19.2697 16.7331 19.7368 17.6228C20.0877 18.3171 20.0877 19.1437 19.7368 19.8381C19.2697 20.7278 18.2229 21.3149 16.4926 21.6174C15.7216 21.7729 14.9412 21.874 14.1568 21.9199C13.4301 22 12.7034 22 11.968 22H10.6444C10.3675 21.9644 10.0994 21.9466 9.83981 21.9466C9.05538 21.9063 8.27477 21.8082 7.50397 21.653C5.83428 21.3327 4.74422 20.7633 4.27705 19.8737C4.09671 19.529 4.00163 19.144 4.0001 18.7527C3.99646 18.3589 4.08866 17.9705 4.2684 17.6228C4.72692 16.7331 5.81698 16.1548 7.50397 15.8434C8.27816 15.6915 9.06144 15.5934 9.84846 15.5498ZM12.0026 2C14.9028 2 17.2539 4.41782 17.2539 7.40036C17.2539 10.3829 14.9028 12.8007 12.0026 12.8007C9.10241 12.8007 6.75131 10.3829 6.75131 7.40036C6.75131 4.41782 9.10241 2 12.0026 2Z" fill="#200E32"/>
                </g>
              </svg>
              {{user.name | titlecase}}
            </div>
            <div class="appln-desc">{{ i >0? 'Co-applicant' : 'Applicant'}}</div>
            <div class="appln-status">{{user.signed? 'Completed':'Pending'}}</div>
          </div>
          <!-- <div class="appln-item completed">
            <div class="appln-name">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g id="profile">
                <path id="Vector" d="M9.84846 15.5498C11.2881 15.4338 12.7344 15.4338 14.1741 15.5498C14.9581 15.5955 15.7383 15.6936 16.5099 15.8434C18.1796 16.1815 19.2697 16.7331 19.7368 17.6228C20.0877 18.3171 20.0877 19.1437 19.7368 19.8381C19.2697 20.7278 18.2229 21.3149 16.4926 21.6174C15.7216 21.7729 14.9412 21.874 14.1568 21.9199C13.4301 22 12.7034 22 11.968 22H10.6444C10.3675 21.9644 10.0994 21.9466 9.83981 21.9466C9.05538 21.9063 8.27477 21.8082 7.50397 21.653C5.83428 21.3327 4.74422 20.7633 4.27705 19.8737C4.09671 19.529 4.00163 19.144 4.0001 18.7527C3.99646 18.3589 4.08866 17.9705 4.2684 17.6228C4.72692 16.7331 5.81698 16.1548 7.50397 15.8434C8.27816 15.6915 9.06144 15.5934 9.84846 15.5498ZM12.0026 2C14.9028 2 17.2539 4.41782 17.2539 7.40036C17.2539 10.3829 14.9028 12.8007 12.0026 12.8007C9.10241 12.8007 6.75131 10.3829 6.75131 7.40036C6.75131 4.41782 9.10241 2 12.0026 2Z" fill="#200E32"/>
                </g>
              </svg>
              Adhitya Samanth
            </div>
            <div class="appln-desc">Applicant</div>
            <div class="appln-status">Completed</div>
          </div> -->
        </div>
        <div class="page-action">
          <button class="btn-primary" *ngIf="!isAllSigned" [disabled]="!userSelected || userSelected?.signed" (click)="eSigned()">Continue</button>
          <button class="btn-primary" *ngIf="isAllSigned"  (click)="eSigned()">Continue</button>
        </div>
      </div>
    </div>
  </div>
</section>
<app-esign-web-view *ngIf="url" [url]="urlS" [id]="userSelected.signerRefId" (userEsigned)="onEsigned($event)"></app-esign-web-view>



<p-dialog [(visible)]="professingFeePopup" [modal]="true" styleClass="cus-dialog-md cus-dialog processing-fee-dialog" [draggable]="false" [resizable]="false">
  <div class="fee-content">
    <div class="dialog-title">Processing Fee</div>
    <div class="dialog-info">Please select the mode of payment by which you would like to pay.</div>
    <div class="fee-inner">
      <div class="gradient-line"></div>
      <div class="fee-left">
        <img src="assets/images/dialog/processing_fee.svg" alt="Processing Fees"/>
      </div>
      <div class="fee-right">
        <div class="amount-info">Amount Payable</div>
        <div class="amount"><span class="lite">₹</span>50,000</div>
        <div class="fee-action">
          <button class="btn-primary">Continue</button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
